import { render, staticRenderFns } from "./ConfigAlertServiceNow.vue?vue&type=template&id=7acff420&scoped=true"
import script from "./ConfigAlertServiceNow.vue?vue&type=script&lang=js"
export * from "./ConfigAlertServiceNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acff420",
  null
  
)

export default component.exports